var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconRecruitNotice24 = function SvgIconRecruitNotice24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9.756a.86.86 0 1 0 0 1.72.86.86 0 0 0 0-1.72Zm-2.36.86a2.36 2.36 0 1 1 4.72 0 2.36 2.36 0 0 1-4.72 0ZM8.035 15.59c0-.949.766-1.714 1.715-1.714h4.505c.95 0 1.715.765 1.715 1.715v1.45h-1.5v-1.45a.212.212 0 0 0-.215-.215H9.75a.212.212 0 0 0-.215.215v1.45h-1.5v-1.45Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.3 6.35a.95.95 0 0 0-.95.95v9.4c0 .525.426.95.95.95h9.4a.95.95 0 0 0 .95-.95V7.3a.95.95 0 0 0-.95-.95H7.3Zm-2.65.95A2.65 2.65 0 0 1 7.3 4.65h9.4a2.65 2.65 0 0 1 2.65 2.65v9.4a2.65 2.65 0 0 1-2.65 2.65H7.3a2.65 2.65 0 0 1-2.65-2.65V7.3Z",
    fill: "current"
  })));
};
export default SvgIconRecruitNotice24;